module.exports = __webpack_public_path__ + "img/logo-dark.8ab98bd9.png";